import { Component, OnInit,Input,Output,EventEmitter,ViewChild } from '@angular/core';
import {PaymentOptionsComponent} from "../payment-options/payment-options.component";
@Component({
  selector: 'app-prepaid',
  templateUrl: './prepaid.component.html',
  styleUrls: ['./prepaid.component.sass']
})
export class PrepaidComponent implements OnInit {
  @ViewChild(PaymentOptionsComponent,{static: false}) paymentOptionsComp: PaymentOptionsComponent;
  public selectBan;
  public token;
  public cr='';
  public billBalanceX=0;
  public type="prepaid";
  @Input() subscribers;
  @Input() subscriber;
  @Input() accountType;
  @Input() accountSubtype;
  @Input() currentList;
  @Input() paperless;
  @Input() billBalanceField;
  @Input() endDateField;

  @Output() updateBillBalanceField = new EventEmitter();
  @Output() updateinitializeData = new EventEmitter();

  constructor() { }
  ngOnInit() {
    this.token=sessionStorage.getItem("token");
  }
  initializeData(){
    this.updateinitializeData.emit();
  }
  updateCredit(selectBan,billBalanceField,type){
    this.selectBan=selectBan;
   // this.billBalanceField=prepaidBalance;
    //this.updateBillBalanceField.next(prepaidBalance);
    this.type=type;
    //this.paymentOptionsComp.updateCredit(this.selectBan,prepaidBalance,type);
  }
}
